import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { RouterView } from 'vue-router'
import signVue from '../components/sign.vue'
import anchorVue from '../components/anchor.vue'
import commentVue from '../components/comment.vue'
import dialogVue from '../components/dialog.vue'
import editorVue from '../components/editor.vue'
import iconVue from '../components/icon.vue'
import noticeBarVue from '../components/notice-bar.vue'
import searchVue from '../components/search.vue'
import tagsVue from '../components/tags.vue'
import testVue from '../components/test.vue'
import chatVue from '../components/chat.vue'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import modalVue from '../components/modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const components = [
  commentVue,
  chatVue,
  searchVue,
  noticeBarVue,
  anchorVue,
  dialogVue,
  editorVue,
  iconVue,
  tagsVue,
  testVue,
  signVue,
  modalVue
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElConfigProvider), { locale: _unref(zhCn) }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_unref(RouterView), {
          components: components,
          title: "组件列表"
        })
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})